import type React from 'react'

function SearchIcon(): React.ReactElement {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  )
}

/**
 * Top-bar omni-search. Visual placeholder only — wired up in a follow-up.
 */
export function OmniSearch(): React.ReactElement {
  return (
    <label
      className="flex w-full max-w-md items-center gap-2 rounded-full border border-border bg-surface px-3 py-1.5 text-sm text-muted-foreground"
      data-testid="omni-search"
    >
      <SearchIcon />
      <input
        type="search"
        disabled
        placeholder="Search plans, answers..."
        className="flex-1 bg-transparent outline-none placeholder:text-muted-foreground"
        aria-label="Search plans and answers"
      />
      <span className="hidden rounded-md border border-border px-1.5 py-0.5 font-mono text-xs text-muted-foreground sm:inline">
        ⌘K
      </span>
    </label>
  )
}
